import React, { memo } from 'react'
import Ckeckbox from './Checkbox'

/**
 * MULTIPLECHOICE
 * @param {{ options: Array<{name: string, value: string}>, questionNumber: string}} props 
 * @returns {JSX.Element}
 */
function MultipleChoice({ options, questionNumber, ...props }) {
  return (
    <div>
      {options.map((option, key) => <Ckeckbox key={key} options={options} valueType={option.name.startsWith('other') ? 'input' : 'text'} questionNumber={questionNumber} option={option} {...props} />)}
      <p className='mt-1 hidden invisible peer-invalid:visible text-red-600 text-sm'>Cette question est requise.</p>
    </div>
  )
}

export default memo(MultipleChoice)